import { type RtkQueryLayers } from '../../core';
import { institutionOGService } from './institutions.og';

export const institutionRTKQueryLayers: RtkQueryLayers = {
  reducers: {
    institutionOGReducerFromLibrary: institutionOGService.reducer,
  },
  middlewares: [institutionOGService.middleware],
};
